module.exports = __webpack_public_path__ + "static/media/hampster-2.13bd22e7.mp3";